import { jsx as _jsx } from "react/jsx-runtime";
import { ArrowUpS } from '@lichtblick/photon/icons/arrows/arrow-up-s';
import classNames from 'classnames';
import styles from './back-to-top-button.module.scss';
export const BackToTopButton = ({ visible })=>/*#__PURE__*/ _jsx("button", {
        className: classNames(styles.button, visible && styles.visible),
        onClick: ()=>{
            scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
        tabIndex: -1,
        type: "button",
        children: /*#__PURE__*/ _jsx(ArrowUpS, {})
    });

//# sourceMappingURL=BackToTopButton.js.map